/**
 * Wordpress Related Constants
 **/

const WP = {
  DATE_FORMATS: [
    { key: "F j, Y", label: "November 6, 2015" },
    { key: "n/d/y", label: "11/6/15" },
    { key: "n/d/Y", label: "11/6/2015" },
    { key: "M j", label: "Nov 6" },
    { key: "M j, Y", label: "Nov 6, 2015" },
    { key: "F j, Y g:i a", label: "November 6, 2015 12:50 am" },
    { key: "l, F jS, Y", label: "Saturday, November 6th, 2015" },
    { key: "custom", label: "Custom..." },
  ],

  PLACEHOLDERS: [
    { key: "post_title", label: "Post Title" },
    { key: "post_author", label: "Post Author" },
    { key: "post_date", label: "Post Date" },
    { key: "post_content", label: "Post Content" },
    { key: "post_excerpt", label: "Post Excerpt" },
    { key: "post_comments", label: "Post Comments" },
    { key: "post_categories", label: "Post Categories" },
    { key: "post_category", label: "Post Top Category" },
    { key: "comment_link", label: "Comment Link" },
    { key: "comment_form", label: "Comment Form" },
    { key: "comment_count", label: "Comment Count" },
    { key: "previous_post_link", label: "Previous Single Post Link" },
    { key: "next_post_link", label: "Next Single Post Link" },
    { key: "previous_posts_link", label: "Newer Posts Link" },
    { key: "next_posts_link", label: "Older Posts Link" },
    { key: "the_category", label: "Category Title" },
    { key: "post_tags", label: "Tags" },
    { key: "sidebar", label: "Sidebar 1" },
    { key: "sidebar2", label: "Sidebar 2" },
    { key: "sidebar3", label: "Sidebar 3" },
    { key: "search_form", label: "Search Bar" },
    { key: "mixed", label: "Advanced Content Replace" },
  ],
  TEMPLATE_INDEX: "index",
  TEMPLATE_SINGLE: "single",
  TEMPLATE_CATEGORY: "category",
  TEMPLATE_TAG: "tag",
  TEMPLATE_ARCHIVE: "archive",
  TEMPLATE_SEARCH: "search",
  TEMPLATE_PAGE: "page",
  TEMPLATE_FRONT_PAGE: "front-page",
  TEMPLATE_HOME: "home",
  TEMPLATE_TAXONOMY: "taxonomy",
  TEMPLATE_AUTHOR: "author",
  TEMPLATE_ATTACHMENT: "attachment",
  TEMPLATE_IMAGE: "image",
  TEMPLATE_404: "404",
  TEMPLATE_GLOBAL: "global",
  TEMPLATE_CUSTOM: "custom",
};

export const WP_TEMPLATE_OPTIONS = [
  { key: WP.TEMPLATE_INDEX, label: "Post List (Default)" },
  { key: WP.TEMPLATE_SINGLE, label: "Single Post" },
  { key: WP.TEMPLATE_CATEGORY, label: "Category" },
  { key: WP.TEMPLATE_TAG, label: "Tag" },
  { key: WP.TEMPLATE_ARCHIVE, label: "Archive" },
  { key: WP.TEMPLATE_SEARCH, label: "Search" },
  { key: WP.TEMPLATE_PAGE, label: "Page" },
  { key: WP.TEMPLATE_FRONT_PAGE, label: "Front Page" },
  { key: WP.TEMPLATE_HOME, label: "Home" },
  { key: WP.TEMPLATE_TAXONOMY, label: "Taxonomy" },
  { key: WP.TEMPLATE_AUTHOR, label: "Author" },
  { key: WP.TEMPLATE_ATTACHMENT, label: "Attachment" },
  { key: WP.TEMPLATE_IMAGE, label: "Image" },
  { key: WP.TEMPLATE_404, label: "404" },
  { key: "disabled", label: "----------------" },
  { key: WP.TEMPLATE_GLOBAL, label: "Global Template" },
  { key: "disabled", label: "----------------" },
  { key: WP.TEMPLATE_CUSTOM, label: "Custom" },
];

export const PAGINATED_TEMPLATE_TYPES = {
  [WP.TEMPLATE_INDEX]: true,
  [WP.TEMPLATE_CATEGORY]: true,
  [WP.TEMPLATE_TAG]: true,
  [WP.TEMPLATE_ARCHIVE]: true,
  [WP.TEMPLATE_SEARCH]: true,
  [WP.TEMPLATE_TAXONOMY]: true,
  [WP.TEMPLATE_CUSTOM]: true,
  [WP.TEMPLATE_HOME]: true,
};

export default WP;
